import { useState, useEffect } from 'react'
import { Auth } from 'aws-amplify'
import axios from 'axios'
import SpeciesList from './SpeciesList'

const Species = () => {
    const [speciesData, setSpeciesData] = useState([])
    const [errorMsg, setErrorMsg] = useState('')
    const [loading, setLoading] = useState(false)
    const [saving, setSaving] = useState(false)
    const [adding, setAdding] = useState(false)
    const [newSpeciesName, setNewSpeciesName] = useState(null)

    useEffect (() => {
      getSpecies()
    }, [])

    const getSpecies = async () => {

        setErrorMsg('')
        setLoading(true)
        setSpeciesData([])
        let session = await Auth.currentSession()
        let jwt = session.getIdToken().getJwtToken()

        axios
        .get(`${process.env.REACT_APP_API_URL}/species`,
        {headers: {Authorization: jwt}}
        )
        .then(response => {
            setSpeciesData(response.data.rows)
            setLoading(false)
            console.log('WHATS HERE: ', speciesData)
        })
        .catch(error => {
            console.log('The error is: ', error)
            setErrorMsg('Problem retrieving data: ', error)
            setLoading(false)
        })            
    }

    const addNewClick = () => {
      setAdding(true)
    }

    const onCancelClick = () => {
      setNewSpeciesName(null)
      setAdding(false)
    }

    const saveSpecies = async (e) => {
      e.preventDefault()

      setErrorMsg('')
      setSaving(true)
      let session = await Auth.currentSession()
      let jwt = session.getIdToken().getJwtToken()
      axios
          .put(`${process.env.REACT_APP_API_URL}/species`, {updateType: 'insert', speciesName: newSpeciesName},
          {headers: {Authorization: jwt}}
          )
          .then(response => {
              setSpeciesData(response.data.rows.map(newSpeciesItem => {
                  return newSpeciesItem
              }))
              setSaving(false)
              setNewSpeciesName(null)
              setAdding(false)
          })
          .catch(error => {
              console.log('The error is: ', error)
              setErrorMsg('Problem saving data: ', error)
              setSaving(false)
          })            
    }

    return (
        <div className="report">
          <h2>Species</h2>
          { loading && <h3>Loading...</h3>}
          {errorMsg && <p className="form__error">{errorMsg}</p>}
          {!adding && <button className="button" onClick={addNewClick} disabled={loading || adding}>Add New</button>}
          {adding && <div>
            <h4>New Species:</h4>
            { saving && <h3>Saving...</h3>}
            <table className="styled-table">
              <thead>
                <tr>
                  <th>Species Name</th>
                  <th></th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <input 
                    type="text"
                    min="0"
                    className="text-input__customer-add"
                    name="speciesName"
                    value={newSpeciesName}
                    disabled={saving}
                    onChange={e => setNewSpeciesName(e.target.value) } />
                  </td>
                  <td>
                    <button className="table-button" onClick={onCancelClick} disabled={saving}>Cancel</button>
                  </td>
                  <td>
                    <button className="table-button" onClick={saveSpecies} disabled={saving || !newSpeciesName} >Add</button>
                  </td>
                </tr>
              </tbody>
            </table>              
          </div>}
          {speciesData.length > 0 && <div >
            <h4>Current Species:</h4>
            <table className="styled-table styled-table__fixed">
              <thead>
                  <tr>
                      <th>Species Name</th>
                      <th></th>
                      <th></th>
                  </tr>
              </thead>
              <tbody>
                {speciesData.map((speciesItem) => (
                  <SpeciesList
                    key={speciesItem.species_id}
                    speciesItem={speciesItem}
                    setSpeciesData={setSpeciesData}
                    setErrorMsg={setErrorMsg}
                  />
                ))}
              </tbody>
            </table>
          </div>}
        </div>
    )
}

export default Species